export const ACCEPTING_NEW_PATIENT_REASON = {
    off_by_autodecline: 'ACPTNEWPATIENTREASON_OFFAUTODECLINE',
    off_by_admin: 'ACPTNEWPATIENTREASON_OFFADMIN',
    off_by_provider: 'ACPTNEWPATIENTREASON_OFFPROVIDER',
    on_by_admin: 'ACPTNEWPATIENTREASON_ONADMIN',
    on_by_provider: 'ACPTNEWPATIENTREASON_ONPROVIDER',
    off_no_licenses: 'ACPTNEWPATIENTREASON_OFFNOLICENSE'
}